import type { ThemePreset } from './ThemePreset';

/**
 * Built-in themes. Two of them are lifted verbatim from presentations Alex has reviewed
 * on device (hero-story -> arkturian-red, flora-hex -> forest-night); the others are
 * derived from the same value ranges so a customer gets a usable look without tuning.
 *
 * Font families must be members of the AppSettingsData.labelFontFamily option list.
 */
export const BUILT_IN_THEMES: readonly ThemePreset[] = [
    {
        name: 'arkturian-red',
        label: 'Arkturian Rot',
        description: 'Markenrot mit cremefarbener Schrift. Die Startvorlage des Presenters.',
        values: {
            backgroundGradientColor1: '#cc0000',
            backgroundGradientColor2: '#990000',
            backgroundGradientAngle: 180,
            ambientLightIntensity: 2.5,
            keyLightIntensity: 4.0,
            keyLightColor: '#ffffff',
            fillLightIntensity: 2.0,
            fillLightColor: '#ffcccc',
            primaryRoughness: 0.25,
            primaryMetalness: 0.05,
            labelColor: '#fff5ee',
            labelBackgroundColor: '#00000000',
            labelFontFamily: 'Georgia',
            labelBackgroundMode: 'line',
        },
    },
    {
        name: 'forest-night',
        label: 'Wald bei Nacht',
        description: 'Tiefes Grün, warme Schrift auf halbtransparentem Grund. Aus der Flora-Präsentation.',
        values: {
            backgroundGradientColor1: '#16241a',
            backgroundGradientColor2: '#060d08',
            backgroundGradientAngle: 180,
            ambientLightIntensity: 2.6,
            keyLightIntensity: 3.2,
            keyLightColor: '#ffffff',
            fillLightIntensity: 1.6,
            fillLightColor: '#cfe6d2',
            primaryRoughness: 0.55,
            primaryMetalness: 0.0,
            labelColor: '#f3ead2',
            labelBackgroundColor: '#0d1710b3',
            labelFontFamily: 'Georgia',
            labelBackgroundMode: 'line',
        },
    },
    {
        name: 'paper',
        label: 'Papier',
        description: 'Helles Naturpapier, dunkle Schrift. Für Text- und Bildgeschichten mit viel Weißraum.',
        values: {
            backgroundGradientColor1: '#f6f1e8',
            backgroundGradientColor2: '#e3d9c8',
            backgroundGradientAngle: 160,
            ambientLightIntensity: 2.2,
            keyLightIntensity: 2.6,
            keyLightColor: '#fff8ee',
            fillLightIntensity: 1.8,
            fillLightColor: '#ffffff',
            primaryRoughness: 0.8,
            primaryMetalness: 0.0,
            labelColor: '#2b2118',
            labelBackgroundColor: '#ffffffcc',
            labelFontFamily: 'Georgia',
            labelBackgroundMode: 'line',
        },
    },
    {
        name: 'studio-dark',
        label: 'Studio Dunkel',
        description: 'Neutrales Anthrazit, kühle Schrift, leicht metallische Objekte. Für Produkte.',
        values: {
            backgroundGradientColor1: '#1b1d22',
            backgroundGradientColor2: '#08090b',
            backgroundGradientAngle: 180,
            ambientLightIntensity: 2.0,
            keyLightIntensity: 3.6,
            keyLightColor: '#ffffff',
            fillLightIntensity: 2.2,
            fillLightColor: '#dfe6f2',
            primaryRoughness: 0.35,
            primaryMetalness: 0.3,
            labelColor: '#f2f2f2',
            labelBackgroundColor: '#000000b3',
            labelFontFamily: 'Helvetica',
            labelBackgroundMode: 'line',
        },
    },
    {
        name: 'ocean',
        label: 'Ozean',
        description: 'Tiefblau mit heller Schrift. Ruhig, für Landschaft, Wasser und Technik.',
        values: {
            backgroundGradientColor1: '#0b3d5c',
            backgroundGradientColor2: '#041b2b',
            backgroundGradientAngle: 180,
            ambientLightIntensity: 2.4,
            keyLightIntensity: 3.4,
            keyLightColor: '#ffffff',
            fillLightIntensity: 2.0,
            fillLightColor: '#bfe0ff',
            primaryRoughness: 0.4,
            primaryMetalness: 0.1,
            labelColor: '#e8f4ff',
            labelBackgroundColor: '#06283db3',
            labelFontFamily: 'Arial',
            labelBackgroundMode: 'line',
        },
    },
];
